import { createConfig } from '@privy-io/wagmi';
import { http } from 'wagmi';
import { chains } from 'mode-shared/constants/chains';

export const wagmiConfig = createConfig({
  chains,
  transports: Object.fromEntries(chains.map((chain) => [chain.id, http()])),
});
